import React from "react";
import Header from "./Header";
import Footer from './Footer'

export default function Blogs() {
  return (
    <>
      <Header />
      <div>
        <div class="container-fluid px-0">
          <img
            src="https://landkit.goodthemes.co/assets/img/covers/cover-13.jpg"
            alt="Snow"
            className='w-100'
            style={{height:700}}
          />
          <div class="centered text-white">Our Newsroom</div>
          <div class="centeredSub text-white">Keep up to date with what we're working on! Landkit is an ever evolving theme with regular updates.</div>
        </div>
        <section class="pt-7 pt-md-10 bg-success">
      <div class="container">
        <div class="row">
          <div class="col-12">

            <div class="card card-row shadow-light-lg mb-6 lift lift-lg">
              <div class="row no-gutters">
                <div class="col-12">

                  <span class="badge badge-pill badge-light badge-float badge-float-inside">
                    <span class="h6 text-uppercase">Featured</span>
                  </span>

                </div>
                <a class="col-12 col-md-6 order-md-2 bg-cover card-img-right"  href="#!">

                  <img src="assets/img/photos/photo-27.jpg" alt="..." class="img-fluid d-md-none invisible"/>

                  <div class="shape shape-left shape-fluid-y svg-shim text-white d-none d-md-block">
                    <svg viewBox="0 0 112 690" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h62.759v172C38.62 384 112 517 112 517v173H0V0z" fill="currentColor"></path></svg>
                  </div>

                </a>
                <div class="col-12 col-md-6 order-md-1">

                  <a class="card-body" href="#!">

                    <h3>
                      Travel Can Keep You Creatively Inspired.
                    </h3>

                    <p class="mb-0 text-muted">
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit. Duis nec condimentum quam. Fusce pellentesque faucibus lorem at viverra. Integer at feugiat odio. In placerat euismod risus proin erat purus.
                    </p>

                  </a>

                  <a class="card-meta" href="#!">

                    <hr class="card-meta-divider"/>

                    <div class="avatar avatar-sm mr-2">
                      <img src="assets/img/avatars/avatar-1.jpg" alt="..." class="avatar-img rounded-circle"/>
                    </div>

                    <h6 class="text-uppercase text-muted mr-2 mb-0">
                      Ab Hadley
                    </h6>

                    <p class="h6 text-uppercase text-muted mb-0 ml-auto">
                      <time datetime="2019-05-02">May 02</time>
                    </p>

                  </a>

                </div>

              </div> 
            </div>

          </div>
        </div>
      </div> 
    </section>
      </div>
      <Footer/>
    </>
  );
}
